import { render, staticRenderFns } from "./UpdateScheduler.vue?vue&type=template&id=55834512&scoped=true"
import script from "./UpdateScheduler.vue?vue&type=script&lang=js"
export * from "./UpdateScheduler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55834512",
  null
  
)

export default component.exports